import React, { useEffect, useMemo, useRef, useState } from "react";

export default function SearchableSelect({
  name,
  value,
  onChange,
  options = [],
  placeholder = "-- Seleziona --",
  disabled = false,
}) {
  const wrapperRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");

  const selected = useMemo(
    () => options.find((o) => String(o.value) === String(value)) || null,
    [options, value]
  );

  useEffect(() => {
    setQuery(selected ? selected.label : "");
  }, [selected]);

  const filtered = useMemo(() => {
    const q = query.toLowerCase();
    return options.filter((o) => o.label.toLowerCase().includes(q));
  }, [options, query]);

  // 👉 AUTO-SELEZIONE SE UNIVOCO
  useEffect(() => {
    if (!open) return;

    if (filtered.length === 1) {
      const unico = filtered[0];

      if (String(unico.value) !== String(value)) {
        onChange({
          target: {
            name,
            value: unico.value,
          },
        });
      }

      setQuery(unico.label);
      setOpen(false);
    }
  }, [filtered, open]);

  useEffect(() => {
    function clickOutside(e) {
      if (!wrapperRef.current?.contains(e.target)) setOpen(false);
    }
    document.addEventListener("mousedown", clickOutside);
    return () => document.removeEventListener("mousedown", clickOutside);
  }, []);

  function selectOption(opt) {
    onChange({
      target: {
        name,
        value: opt.value,
      },
    });
    setQuery(opt.label);
    setOpen(false);
  }

  return (
    <div ref={wrapperRef} style={{ position: "relative" }}>
      <input
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
        placeholder={placeholder}
        disabled={disabled}
        style={{
          width: "100%",
          padding: 8,
          borderRadius: 8,
          border: "1px solid rgba(255,255,255,0.15)",
          background: "rgba(255,255,255,0.06)",
          color: "white",
        }}
      />

      {open && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            background: "#1f2937",
            border: "1px solid rgba(255,255,255,0.15)",
            borderRadius: 8,
            maxHeight: 200,
            overflowY: "auto",
            zIndex: 999,
          }}
        >
          {filtered.map((opt) => (
            <div
              key={opt.value}
              onClick={() => selectOption(opt)}
              style={{
                padding: 8,
                cursor: "pointer",
                color: "white",
              }}
            >
              {opt.label}
            </div>
          ))}

          {filtered.length === 0 && (
            <div style={{ padding: 8, color: "#9ca3af" }}>
              Nessun risultato
            </div>
          )}
        </div>
      )}
    </div>
  );
}